var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpedia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "expedia-vector-logo_2",
    "data-name": "expedia-vector-logo 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 30,
    viewBox: "0 0 104 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M11.491,10.332H8.267c-.017,0-.017,0-.035-.018L5.442,6.853l-2.79,3.462c0,.018-.017.018-.035.018H.035c-.017,0-.035,0-.035-.018v-.035L4.108,5.157.052.071a.033.033,0,0,1,0-.053C.052,0,.069,0,.087,0H3.328a.053.053,0,0,1,.035.018L5.806,3.109,8.285.018C8.285,0,8.3,0,8.319,0h2.634a.06.06,0,0,1,.035.018V.071L7.141,4.751l4.385,5.511c.017.018.017.035,0,.035a.038.038,0,0,1-.035.035",
    transform: "translate(38.503 13.15)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M5.495,11.233A5.374,5.374,0,0,1,0,5.617,5.374,5.374,0,0,1,5.495,0,4.738,4.738,0,0,1,8.97,1.34a4.777,4.777,0,0,1,1.291,3.393c-.013.331-.056,1-.076,1.318v.005c-.007.1-.011.174-.011.178-.017.017-.017.017-.034.017h-7.4A2.823,2.823,0,0,0,5.824,9.008a8.4,8.4,0,0,0,3.969-1.29.059.059,0,0,1,.027-.007.041.041,0,0,1,.042.042v2.314a.059.059,0,0,1-.018.035A11.788,11.788,0,0,1,5.495,11.233Zm-.018-8.99A2.635,2.635,0,0,0,2.79,4.663H7.661V4.557A2.429,2.429,0,0,0,7.05,2.943,2.1,2.1,0,0,0,5.477,2.243Z",
    transform: "translate(62.005 12.709)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M.277,15.79V5.511a.037.037,0,0,1,.035-.035H2.981a.037.037,0,0,1,.035.035V15.773a.038.038,0,0,1-.035.035H.312v.018C.277,15.826.277,15.808.277,15.79ZM0,1.7A1.677,1.677,0,0,1,1.646,0,1.677,1.677,0,0,1,3.293,1.7,1.647,1.647,0,0,1,0,1.7Z",
    transform: "translate(85.542 7.657)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M0,17.292H0V.459A.038.038,0,0,1,.035.424H2.687A6.826,6.826,0,0,1,4.991,0a5.293,5.293,0,0,1,5.459,5.564c0,3.444-2.354,5.669-6,5.669a13.138,13.138,0,0,1-1.715-.158V16.2A6.061,6.061,0,0,1,0,17.292ZM4.541,2.084A5.911,5.911,0,0,0,2.721,2.4V8.99a5.641,5.641,0,0,0,1.543.229c2.043,0,3.362-1.442,3.362-3.674C7.626,3.475,6.386,2.084,4.541,2.084Z",
    transform: "translate(50.618 12.709)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M8.06,17.45h0v-.935a6.525,6.525,0,0,1-3.051.83C2.106,17.344,0,15.012,0,11.8A5.494,5.494,0,0,1,5.564,6.129a7.509,7.509,0,0,1,2.166.336V1.1A5.9,5.9,0,0,1,10.451,0V16.408a5.876,5.876,0,0,1-2.39,1.042ZM6.032,8.177c-1.948,0-3.207,1.484-3.207,3.78,0,1.99.985,3.179,2.634,3.179a4.848,4.848,0,0,0,2.271-.653V8.6A4.1,4.1,0,0,0,6.032,8.177Z",
    transform: "translate(73.271 6.598)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M8.112,11.3h0V9.979a3.369,3.369,0,0,1-2.894,1.237C2.1,11.216,0,9.023,0,5.758A5.493,5.493,0,0,1,5.321,0,6.616,6.616,0,0,1,8.007.653H8.06V.283A.12.12,0,0,1,8.181.159h2.166c.075,0,.122.04.122.105l-.018,10A6.237,6.237,0,0,1,8.113,11.3ZM5.893,2.066c-1.856,0-3.1,1.519-3.1,3.78,0,1.99,1.056,3.179,2.825,3.179A4.194,4.194,0,0,0,7.73,8.319V2.667A4.091,4.091,0,0,0,5.893,2.066Z",
    transform: "translate(90.082 12.744)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M2.86,14.041H9.567A6.121,6.121,0,0,1,8.631,16.6H1.664A1.681,1.681,0,0,1,.017,15.084c0-.018,0-.018-.017-.035V1.572c0-.018,0-.035.017-.035A1.684,1.684,0,0,1,1.664,0H9.55a6.438,6.438,0,0,1-.936,2.579H2.86V6.252H8.545c.035,0,.035.018.035.035V8.831a.038.038,0,0,1-.035.035H2.86v5.175Z",
    transform: "translate(28.312 6.862)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M1.265,2.614A1.244,1.244,0,0,1,0,1.307a1.257,1.257,0,1,1,2.513,0A1.236,1.236,0,0,1,1.265,2.614Zm0-2.49A1.086,1.086,0,0,0,.191,1.29,1.1,1.1,0,0,0,1.265,2.472,1.088,1.088,0,0,0,2.323,1.29,1.091,1.091,0,0,0,1.265.123Z",
    transform: "translate(101.487 12.355)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M.243,1.537H0V0H.572c.383,0,.554.136.554.442a.382.382,0,0,1-.4.424l.415.669-.276,0L.468.883H.243v.653Zm0-1.343V.653H.537C.729.653.9.634.9.406.9.22.726.194.554.194Z",
    transform: "translate(102.215 12.885)",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M14.134,9.459l-.485-1.4L9.524,2.447l.745-.194,7.106,6.252,4.177-1.219a6.252,6.252,0,0,1,1.473-.159A11.99,11.99,0,0,0,.7,8.187a12.629,12.629,0,0,0-.572,5.97l10.018-3.55Z",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M23.207,0a6.147,6.147,0,0,1-1.439.742L17.575,1.961,14.767,11.11l-.728.247.589-6.994L14.3,2.914l-3.917,1.13L0,6.535a12.268,12.268,0,0,0,7.782,9.114A12,12,0,0,0,23.19,8.2,12.642,12.642,0,0,0,23.207,0",
    transform: "translate(0.269 8.24)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M14.4,8.919l.329,1.448-.589,6.994.728-.247,2.79-9.149,4.194-1.219a6.147,6.147,0,0,0,1.439-.742c-.139-.371-.277-.742-.451-1.113a6.252,6.252,0,0,0-1.473.159L17.193,6.27,10.087,0,9.342.194l4.142,5.617.485,1.4L10.018,8.354,0,11.9l.1.636,10.364-2.473Z",
    transform: "translate(0.165 2.235)",
    fill: "#091e30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpedia);
export default __webpack_public_path__ + "static/media/expedia.afcd35f8e0808e195958cd831cca94f5.svg";
export { ForwardRef as ReactComponent };